import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './SignIn';
import type { AuthResponse } from './types';
import Energy from './Energy';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '@mui/material/styles';
import { useThemeToggle } from './theme';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [authResponse, setAuthResponse] = useState<AuthResponse | null>(null);

  return (
    <Router>
      <div style={{ ...styles.container, background: 'transparent' }}>
        <div style={{ position: 'absolute', top: 8, right: 8 }}>
          <ThemeToggle />
        </div>
        <Routes>
          <Route
            path="/signin"
            element={
              <SignIn
                productName="Spoxmen Energy"
                onSignInSuccess={(fullJson: AuthResponse) => {
                  setAuthResponse(fullJson);
                  setIsAuthenticated(true);
                }}
              />
            }
          />
          <Route
            path="/Energy"
            element={
              isAuthenticated ? (
                <Energy accessToken={authResponse?.accesskey || ''} />
              ) : (
                <Navigate to="/signin" replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

const styles: { container: React.CSSProperties } = {
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};

export default App;

function ThemeToggle() {
  const { mode, toggleMode } = useThemeToggle();
  useTheme();
  return (
    <IconButton onClick={toggleMode} color="inherit" aria-label="Toggle theme">
      {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
}
